import React from 'react';

const ChevronRightNoBorder = () => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.256715 11.169C-0.112745 10.7584 -0.0794661 10.1262 0.331044 9.7567L4.50516 5.99999L0.331044 2.24329C-0.0794658 1.87383 -0.112744 1.24154 0.256715 0.831027C0.626174 0.420517 1.25846 0.387239 1.66897 0.756698L6.66897 5.2567C6.87969 5.44634 7.00001 5.71651 7.00001 5.99999C7.00001 6.28348 6.87969 6.55364 6.66897 6.74329L1.66897 11.2433C1.25846 11.6127 0.626173 11.5795 0.256715 11.169Z"
      fill="#171717"
    />
  </svg>
);

export default ChevronRightNoBorder;
